import { useEffect, useState } from "react";
import Lenis from "lenis";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    const id = requestAnimationFrame(raf);
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.removeEventListener("scroll", onScroll); };
  }, []);

  return (
    <main className="bg-white text-[#0E0E0E] overflow-x-hidden">
      <Nav scrolled={scrolled} />
      <Hero />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
